import api from 'base/utils/api';
import { IEgg, IReward } from './interface';

export async function getEggs(pageCode: string = '', id: string = ''): Promise<IEgg[]> {
    return api.post('/web/surprise/egg/page', {
        data: {
            pageCode,
            id
        }
    }).then(res => res.list);
}

export async function getReward(pageCode: string = '', id: string = ''): Promise<IReward> {
    return api.post('/web/surprise/egg/rewards', {
        data: {
            pageCode,
            id
        }
    });
}

export async function flushRewardsRecord(userId: string = ''): Promise<void> {
    return api.get('/web/surprise/egg/flush/rewards/record', {
        params: {
            activityGid: '159567697325316114',
            userId
        }
    });
}